import { CortexTouchSource } from "./CortexTouchSource";

/**
 * Cortex Session Touch Model
 *
 * @export
 * @class CortexTouch
 * @property {CortexTouchSource} touchSource
 * @property {CortexTouchGroup} touchGroup
 * @property {Date} timestamp
 * @property {string} referrer
 * @property {string} location
 * @property {object} qsValues
 * @property {string} userAgent
 */
export class CortexTouch {
  touchSource: CortexTouchSource;
  timestamp: Date;
  referrer: string;
  location: string;
  qsValues: object;
  userAgent: string;

  /**
   * Creates an instance of CortexTouch.
   * @constructor
   * @memberof CortexTouch
   */
  constructor() {
    const w: Window = window, d: Document = w.document;
    const existingSession = w.sessionStorage.getItem("existingCortexSession");
    const haveReferrer: boolean = d.referrer !== "";


    this.touchSource = CortexTouchSource.Unknown;

    if (existingSession == null) {
      if (haveReferrer) {
        const likelySource: CortexTouchSource = d.location.hostname == new URL(d.referrer).hostname
          ? CortexTouchSource.Direct
          : CortexTouchSource.External;
        this.touchSource = likelySource;
      } else {
        // new session so assume direct open to url
        this.touchSource = CortexTouchSource.Direct;
      }
      w.sessionStorage.setItem("existingCortexSession", this.touchSource);
    }
    else {
      if (haveReferrer) {
        const likelySource: CortexTouchSource = d.location.hostname == new URL(d.referrer).hostname
          ? CortexTouchSource.Direct
          : CortexTouchSource.External;
        this.touchSource = likelySource;
      } else {
        this.touchSource = existingSession as CortexTouchSource;
      }
    }

    this.timestamp = new Date(Date.now());
    this.referrer = d.referrer;
    this.location = d.location.href;
    this.qsValues = {};
    this.userAgent = w.navigator.userAgent;
  }
}

export default {
  CortexTouch,
  CortexTouchSource
}